import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { catchError, throwError } from 'rxjs';

import { Error } from '@sb-tools/typescript/enums/error.enum';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const notificationsService = inject(NotificationsService);
    const translateService = inject(TranslateService);
    const router = inject(Router);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            return handleError(error, notificationsService, translateService, router);
        }),
    );
};

function handleError(
    response: HttpErrorResponse,
    notificationsService: NotificationsService,
    translateService: TranslateService,
    router: Router,
) {
    const error = response.error ?? {};

    if (
        [
            Error.communityWithNameNotFound,
            Error.communityNotFound,
            Error.faqInstanceNotFound,
            Error.categoryNotFound,
            Error.topicNotFound,
            Error.itemNotFound,
        ].includes(error?.errorId)
    ) {
        router.navigate(['404'], {
            skipLocationChange: true,
        });
    } else if (error?.errorId === Error.linkIsExpired) {
        return throwError(() => response);
    } else {
        let message: string;

        if (error && (typeof error === 'string' || error.message)) {
            message = error.message ? error.message : error;
            if (message.toLowerCase().indexOf('timeout') >= 0) {
                message = translateService.instant(
                    'Oops... your action was not completed due to a slow Internet connection. Please wait for a few seconds and try again.',
                );
            }
        } else {
            message = translateService.instant('Oops... Something went wrong, please try again or reload this page');
        }

        notificationsService.error(translateService.instant('Error!'), message);
    }

    return throwError(() => response);
}
